import {
  IconStarFilled,
  IconReceipt,
  IconPercentage,
  IconFlame,
  IconScale,
  IconCash,
  IconAlertTriangle,
} from "@tabler/icons-react";
import { StatCard } from "../../../../components/common/stat-card";
import type { LoyaltyAnalyticsSummaryDto } from "../../hooks/useAdminLoyaltyAnalytics";

interface Props {
  summary: LoyaltyAnalyticsSummaryDto;
}

function fmt(n: number): string {
  return n.toLocaleString();
}

function fmtPct(n: number): string {
  return `${n.toFixed(1)}%`;
}

function fmtCurrency(n: number, currency: string): string {
  return `${currency} ${n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function LoyaltyAnalyticsSummary({ summary }: Props) {
  return (
    <div className="flex flex-col gap-4 max-sm:gap-3">
      <div className="grid grid-cols-2 gap-4 max-sm:grid-cols-1 max-sm:gap-3 lg:grid-cols-4">
        <StatCard
          icon={<IconStarFilled size={24} />}
          iconTone="cyanTint"
          label="Total Issued"
          value={fmt(summary.totalPointsIssued)}
          sub="points"
        />
        <StatCard
          icon={<IconReceipt size={24} />}
          iconTone="cyanTint"
          label="Total Redeemed"
          value={fmt(summary.totalPointsRedeemed)}
          sub="points"
        />
        <StatCard
          icon={<IconPercentage size={24} />}
          iconTone="cyanTint"
          label="Redemption Rate"
          value={fmtPct(summary.redemptionRate)}
        />
        <StatCard
          icon={<IconFlame size={24} />}
          iconTone="ghostMuted"
          label="Expiry Rate"
          value={fmtPct(summary.expiryRate)}
        />
      </div>

      <div className="grid grid-cols-1 gap-4 max-sm:gap-3 sm:grid-cols-3">
        <StatCard
          icon={<IconScale size={24} />}
          iconTone="cyanTint"
          label="Outstanding Liability"
          value={fmt(summary.outstandingPoints)}
          sub="active points"
        />
        <StatCard
          icon={<IconCash size={24} />}
          iconTone="cyanTint"
          label="Liability Value"
          value={fmtCurrency(summary.outstandingValue, summary.currency)}
        />
        <StatCard
          icon={<IconAlertTriangle size={24} />}
          iconTone="ghostMuted"
          label="Expiring Soon"
          value={fmt(summary.expiringSoon)}
          sub="within 30 days"
        />
      </div>
    </div>
  );
}
